import styled from 'styled-components';

import { colors } from '../../constants';

interface IProps {
    transparent?: boolean;
}

export const PriceDivider = styled.div<IProps>`
    width: 100%;
    height: 2px;
    background-color: ${({ transparent }) =>
        transparent ? '#788B8A' : colors.greyLight};
    margin: 10px 0;
`;
